import type { PostSiretVerifyResponse } from "@/app/api/cat/siret-verify/route";
import { useMutation } from "@tanstack/react-query";

const ENDPOINT = "/api/cat/siret-verify";

export function useCatSiretVerifyMutation() {
  return useMutation({
    mutationFn: async (siret: string) => {
      const response = await fetch(ENDPOINT, {
        body: JSON.stringify({ siret }),
        headers: { "Content-Type": "application/json" },
        method: "POST",
      });

      if (response.status === 401) {
        throw new Error("Unauthorized");
      }

      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || "Client error");
      }

      return response.json() as Promise<PostSiretVerifyResponse>;
    },
  });
}
